import { message } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import ConfirmationModal from "../../ui/ConfirmationModal";
import useAllPosFunctions from "../../../../hooks/posCustomHook/useAllPosFunctions";
const MarkNCModal = ({ open, onCancel, invoice,posData, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { updateInvoiceAfterMarkNC } = useAllPosFunctions(setLoading);

  const handleMarkNC = async () => {
    await updateInvoiceAfterMarkNC(invoice,posData, onCancel,onSuccess);
  };

  return (
    <ConfirmationModal
      open={open}
      onCancel={onCancel}
      onConfirm={handleMarkNC}
      title="Mark Invoice as Non-Chargeable"
      description="This invoice will be marked as Non-Chargeable (NC)."
      details={[
        "Total Amount will become ₹0.00",
        "Due Amount will become ₹0.00",
        "No payment will be required",
        "Order can be closed directly",
      ]}
      confirmText="MARK NC"
      cancelText="CANCEL"
      confirmLoading={loading}
    />
  );
};

export default MarkNCModal;
